import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compact, merge, debounce } from 'lodash';
import classNames from 'classnames';
import { createHocName, alignmentClassName, sizeClassName, textWrapClassName } from 'wix-rich-content-common';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z$1 = ".APmcX,.BCdCh,.ReactModalPortal,._52eaQ,.glob_fontElementMap,button{font-family:var(--ricos-font-family,unset)}._7jd3F{display:flex}[dir] .UWgVD{border-radius:var(--ricos-native-whitebox-border-radius,0);box-shadow:0 0 0 3px var(--ricos-focus-action-color,var(--ricos-action-color,#0261ff));cursor:default}._0COSB{display:block;height:100%;position:absolute;top:0;width:100%}[dir] ._0COSB{cursor:move}[dir=ltr] ._0COSB{left:0}[dir=rtl] ._0COSB{right:0}._0COSB._7d4HO{pointer-events:none}[dir] .W7t3M ::selection{background:transparent}.ZtcIo{display:none}.BCdCh,._52eaQ{position:relative}[dir] .BCdCh:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);box-shadow:0 0 0 3px var(--ricos-focus-action-color,var(--ricos-action-color,#0261ff));cursor:default}[dir] .BCdCh:hover.DPFnE{box-shadow:none}.bHmPv{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{font-weight:300}[dir=ltr] .ReactModal__Content{direction:ltr}[dir=rtl] .ReactModal__Content{direction:rtl}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial)}._--doP{color:#333;text-decoration:none}.hWNJK{display:block}.hj241{position:relative}.S7wqU{overflow-x:auto;overflow-y:hidden}[dir=ltr] .S7wqU{margin-left:-20px;margin-right:-20px}[dir=rtl] .S7wqU{margin-left:-20px;margin-right:-20px}[dir] .S7wqU.ErUji::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}[dir] .S7wqU.kGS52::-webkit-scrollbar-thumb{background-color:transparent}.f3yFT{max-width:max-content!important;min-width:100%}.S7wqU::-webkit-scrollbar{-webkit-appearance:none}[dir] .S7wqU::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.S7wqU::-webkit-scrollbar:horizontal{height:10px}";
var styles = {"fontElementMap":"APmcX","pluginContainer":"BCdCh","pluginContainerReadOnly":"_52eaQ","flex":"_7jd3F","hasFocus":"UWgVD","overlay":"_0COSB","noPointerEventsOnFocus":"_7d4HO","hideTextSelection":"W7t3M","hidden":"ZtcIo","noBorder":"DPFnE","pluginContainerMobile":"bHmPv","isImage":"_--doP","anchor":"hWNJK","horizontalScrollbarWrapper":"hj241","pluginWithHorizontalScrollbar":"S7wqU","show":"ErUji","hide":"kGS52","horizontalScrollbar":"f3yFT"};
styleInject(css_248z$1);

var css_248z = ".vXTsR{margin-left:0;margin-right:auto;z-index:1}.vXTsR:not(.QIP-2){float:left;margin-right:40px}.crs1V{margin-left:auto;margin-right:0;z-index:1}.crs1V:not(.QIP-2){float:right;margin-left:40px}._3XTmb{display:block}._3XTmb:not(.XUfm4){margin-left:auto;margin-right:auto;max-width:100%}.QIP-2,.XUfm4{width:100%}.b-thM .QIP-2,.b-thM .XUfm4{margin:0 -8px;width:auto}.If3CT{width:fit-content}.L5LHI{margin-left:auto;margin-right:auto;max-width:100%}.CAVxJ{width:350px!important}.b-thM .CAVxJ{width:50%}._2L5sV{margin-left:auto;margin-right:auto;width:350px!important}.b-thM ._2L5sV{width:150px}.qPZiz{display:flex}";
var rtlIgnoredStyles = {"alignLeft":"vXTsR","textWrapNowrap":"QIP-2","alignRight":"crs1V","alignCenter":"_3XTmb","sizeFullWidth":"XUfm4","renderedInTable":"b-thM","sizeOriginal":"If3CT","sizeContent":"L5LHI","sizeSmall":"CAVxJ","sizeSmallCenter":"_2L5sV","flex":"qPZiz"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const DEFAULTS = Object.freeze({
  alignment: null,
  size: "content",
  url: void 0,
  textWrap: null
});
const createBaseComponent = ({
  PluginComponent,
  theme,
  settings,
  pubsub,
  commonPubsub,
  helpers,
  t,
  isMobile,
  pluginDecorationProps,
  componentWillReceiveDecorationProps,
  getEditorBounds,
  onOverlayClick,
  disableRightClick,
  onComponentMount,
  locale,
  shouldRenderOptimizedImages,
  iframeSandboxDomain,
  setInPluginEditingMode,
  getInPluginEditingMode,
  anchorTarget,
  relValue,
  renderInnerRCE,
  noPluginBorder,
  noPointerEventsOnFocus,
  withHorizontalScroll,
  disableKeyboardEvents,
  type
}) => {
  var _a;
  return _a = class extends Component {
    constructor(props) {
      super(props);
      __publicField(this, "isInViewport", (boundingRect) => {
        const { top, left, bottom, right } = boundingRect;
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const width = window.innerWidth || document.documentElement.clientWidth;
        return top >= 0 && left >= 0 && bottom <= windowHeight && right <= width;
      });
      __publicField(this, "scrollIntoViewIfNeeded", (blockKey, threshold = 0) => {
        if (this.containerRef.current) {
          const boundingRect = this.getBoundingClientRectAsObject(this.containerRef.current);
          const focusedBlock = pubsub.get("focusedBlock");
          if (boundingRect.height === 0 && threshold < 500) {
            setTimeout(() => this.scrollIntoViewIfNeeded(blockKey, threshold + 1), 100);
          } else if (focusedBlock === blockKey && !this.isInViewport(boundingRect)) {
            setTimeout(() => {
              var _a2, _b;
              return (_b = (_a2 = this.containerRef.current) == null ? void 0 : _a2.scrollIntoView) == null ? void 0 : _b.call(_a2);
            }, 100);
          }
        }
      });
      __publicField(this, "onResizeElement", (blockKey) => (element) => {
        const boundingRect = this.getBoundingClientRectAsObject(element[0].target);
        const focusedBlock = pubsub.get("focusedBlock");
        const shouldResize = boundingRect.width !== 0 && focusedBlock === blockKey;
        if (shouldResize) {
          const batchUpdates = {};
          batchUpdates.boundingRect = boundingRect;
          batchUpdates.focusedBlock = focusedBlock;
          pubsub.set(batchUpdates);
        }
      });
      __publicField(this, "isMe", (blockKey) => {
        const { block } = this.props;
        if (blockKey) {
          return blockKey === block.getKey();
        } else {
          return pubsub.get("focusedBlock") === block.getKey();
        }
      });
      __publicField(this, "isMeAndIdle", (blockKey) => {
        return this.isMe(blockKey) && !this.duringUpdate;
      });
      __publicField(this, "onComponentDataChange", (componentData, blockKey) => {
        if (this.isMeAndIdle(blockKey)) {
          this.setState({ componentData: componentData || {} }, () => {
            const {
              blockProps: { setData }
            } = this.props;
            setData(componentData);
          });
        }
      });
      __publicField(this, "onComponentStateChange", (componentState, blockKey) => {
        if (this.isMeAndIdle(blockKey)) {
          this.setState({ componentState: componentState || {} });
        }
      });
      __publicField(this, "onHtmlPluginMaxHeightChange", (htmlPluginMaxHeight) => {
        if (htmlPluginMaxHeight) {
          this.setState({ htmlPluginMaxHeight });
        }
      });
      __publicField(this, "onComponentLinkChange", (linkData) => {
        if (!linkData) {
          this.removeLinkData();
          return;
        }
        const { url, anchor, target, rel } = linkData;
        if (this.isMeAndIdle()) {
          const link = url ? {
            url,
            target,
            rel
          } : { anchor };
          this.updateLinkData(link);
        }
      });
      __publicField(this, "onComponentSpoilerChange", (data) => {
        if (this.isMeAndIdle()) {
          this.updateComponentConfig({ spoiler: data });
        }
      });
      __publicField(this, "updateLinkData", (link) => {
        pubsub.update("componentData", { config: { link: null } });
        pubsub.update("componentData", { config: { link } });
      });
      __publicField(this, "deleteBlock", () => {
        pubsub.set("focusedBlock", null);
        this.props.blockProps.deleteBlock();
      });
      __publicField(this, "handleClick", (e) => {
        if (onOverlayClick) {
          const { componentData } = this.state;
          onOverlayClick({ e, pubsub, componentData });
        }
        const { onClick } = this.props;
        onClick && onClick(e);
      });
      __publicField(this, "updateComponentConfig", (newConfig) => {
        pubsub.update("componentData", { config: newConfig });
      });
      __publicField(this, "getBoundingClientRectAsObject", (element) => {
        const { top, right, bottom, left, width, height, x, y } = element.getBoundingClientRect();
        return { top, right, bottom, left, width, height, x, y };
      });
      __publicField(this, "handleContextMenu", (e) => disableRightClick && e.preventDefault());
      __publicField(this, "setComponentUrl", (url) => this.url = url);
      __publicField(this, "onDragStart", (event) => {
        var _a2;
        this.props.onDragStart(event);
        event.dataTransfer.setData("url", this.url || ((_a2 = window == null ? void 0 : window.location) == null ? void 0 : _a2.href));
      });
      // eslint-disable-next-line complexity
      __publicField(this, "render", () => {
        const { blockProps, className, selection } = this.props;
        const { componentData } = this.state;
        const _a2 = (pluginDecorationProps == null ? void 0 : pluginDecorationProps(this.props, componentData)) || {}, { containerClassName } = _a2, decorationProps = __objRest(_a2, ["containerClassName"]);
        const { width: currentWidth, height: currentHeight } = componentData.config || {};
        const { width: initialWidth, height: initialHeight } = settings || {};
        const isEditorFocused = selection.getHasFocus();
        const isOneBlockSelected = selection.getStartKey() === selection.getEndKey();
        const isPartOfSelection = blockProps.isFocused && !isOneBlockSelected;
        blockProps.isFocused = blockProps.isFocused && isOneBlockSelected;
        const { isFocused } = blockProps;
        const classNameStrategies = compact([
          PluginComponent.alignmentClassName || alignmentClassName,
          PluginComponent.sizeClassName || sizeClassName,
          PluginComponent.textWrapClassName || textWrapClassName,
          PluginComponent.customClassName
        ]).map((strategy) => strategy(this.state.componentData, theme, this.styles, isMobile));
        const hasFocus = (isFocused ? !noPluginBorder : isPartOfSelection) && isEditorFocused;
        const ContainerClassNames = classNames(
          this.styles.pluginContainer,
          theme.pluginContainer,
          theme.pluginContainerWrapper,
          withHorizontalScroll && this.styles.horizontalScrollbar,
          !isPartOfSelection && noPluginBorder && this.styles.noBorder,
          {
            [this.styles.pluginContainerMobile]: isMobile,
            [theme.pluginContainerMobile]: isMobile,
            [containerClassName]: !!containerClassName
          },
          classNameStrategies,
          className || "",
          {
            [this.styles.hasFocus]: hasFocus,
            [theme.hasFocus]: hasFocus,
            [this.styles.hideTextSelection]: !isFocused
          }
        );
        const overlayClassNames = classNames(
          this.styles.overlay,
          theme.overlay,
          isFocused && noPointerEventsOnFocus && this.styles.noPointerEventsOnFocus
        );
        const sizeStyles = withHorizontalScroll ? { position: "unset" } : {
          width: currentWidth || initialWidth,
          height: currentHeight || initialHeight,
          maxHeight: this.state.htmlPluginMaxHeight
        };
        const component = /* @__PURE__ */ React.createElement(
          "div",
          __spreadValues({
            ref: this.containerRef,
            role: "none",
            style: sizeStyles,
            className: ContainerClassNames,
            "data-focus": hasFocus,
            onDragStart: this.onDragStart,
            onContextMenu: this.handleContextMenu
          }, decorationProps),
          /* @__PURE__ */ React.createElement(
            PluginComponent,
            __spreadProps(__spreadValues({}, this.props), {
              isMobile,
              settings,
              store: pubsub.store,
              commonPubsub,
              theme,
              componentData: this.state.componentData,
              componentState: this.state.componentState,
              helpers,
              t,
              editorBounds: getEditorBounds(),
              disableRightClick,
              anchorTarget,
              relValue,
              locale,
              shouldRenderOptimizedImages,
              iframeSandboxDomain,
              setInPluginEditingMode,
              getInPluginEditingMode,
              setComponentUrl: this.setComponentUrl,
              renderInnerRCE,
              disableKeyboardEvents,
              type
            })
          ),
          /* @__PURE__ */ React.createElement(
            "div",
            {
              role: "none",
              "data-hook": "componentOverlay",
              onClick: this.handleClick,
              className: overlayClassNames,
              draggable: true
            }
          )
        );
        return withHorizontalScroll ? /* @__PURE__ */ React.createElement("div", { className: styles.horizontalScrollbarWrapper }, /* @__PURE__ */ React.createElement(
          "div",
          {
            "data-id": "horizontal-scrollbar-element",
            className: classNames(
              styles.pluginWithHorizontalScrollbar,
              blockProps.isFocused ? styles.show : styles.hide
            )
          },
          component
        )) : component;
      });
      this.state = __spreadValues({ componentState: {} }, this.stateFromProps(props));
      this.styles = __spreadValues(__spreadValues({}, styles), rtlIgnoredStyles);
      this.containerRef = React.createRef();
    }
    componentWillReceiveProps(nextProps) {
      componentWillReceiveDecorationProps == null ? void 0 : componentWillReceiveDecorationProps(this.props, nextProps, this.updateComponentConfig);
      this.setState(this.stateFromProps(nextProps));
    }
    stateFromProps(props) {
      const initialState = commonPubsub.get("initialState_" + props.block.getKey());
      if (initialState) {
        commonPubsub.set("initialState_" + props.block.getKey(), void 0);
      }
      return {
        componentData: this.getData(props),
        componentState: initialState || {}
      };
    }
    getData(props) {
      const { getData } = props.blockProps;
      const data = getData() || { config: DEFAULTS };
      if (settings == null ? void 0 : settings.defaultData) {
        merge(data, settings.defaultData);
      }
      return data;
    }
    componentDidMount() {
      var _a2;
      this.updateComponent();
      this.subscriptions = [
        ["componentData", this.onComponentDataChange],
        ["componentState", this.onComponentStateChange]
      ];
      this.subscriptions.forEach((subscription) => pubsub.subscribe(...subscription));
      const blockKey = this.props.block.getKey();
      this.subscriptionsOnBlock = [
        { key: "htmlPluginMaxHeight", callback: this.onHtmlPluginMaxHeightChange },
        { key: "componentLink", callback: this.onComponentLinkChange },
        { key: "componentSpoiler", callback: this.onComponentSpoilerChange }
      ].map(({ key, callback }) => pubsub.subscribeOnBlock({ key, callback, blockKey }));
      const { componentData } = this.state;
      const e = { preventDefault: () => {
      } };
      onComponentMount && onComponentMount({ e, pubsub, componentData });
      if (window == null ? void 0 : window.ResizeObserver) {
        this.resizeObserver = new ResizeObserver(debounce(this.onResizeElement(blockKey), 40));
        (_a2 = this.resizeObserver) == null ? void 0 : _a2.observe(this.containerRef.current);
      }
      this.scrollIntoViewIfNeeded(blockKey);
    }
    componentDidUpdate() {
      this.duringUpdate = true;
      this.updateComponent();
      this.duringUpdate = false;
    }
    componentWillUnmount() {
      var _a2;
      this.subscriptions.forEach((subscription) => pubsub.unsubscribe(...subscription));
      this.subscriptionsOnBlock.forEach((unsubscribe) => unsubscribe());
      this.updateUnselectedComponent();
      (_a2 = this.resizeObserver) == null ? void 0 : _a2.unobserve(this.containerRef.current);
    }
    removeLinkData() {
      const componentData = pubsub.get("componentData");
      const { config } = componentData;
      const _a2 = config, rest = __objRest(_a2, ["link"]);
      pubsub.set("componentData", __spreadProps(__spreadValues({}, componentData), { config: __spreadValues({}, rest) }));
    }
    updateComponent() {
      const { block, blockProps } = this.props;
      if (blockProps.isFocused && blockProps.isCollapsedSelection) {
        this.updateSelectedComponent();
      } else if (pubsub.get("focusedBlock") === block.getKey()) {
        this.updateUnselectedComponent();
      }
    }
    updateSelectedComponent() {
      const { block } = this.props;
      const oldFocusedBlock = pubsub.get("focusedBlock");
      const focusedBlock = block.getKey();
      const blockNode = this.containerRef.current;
      const boundingRect = this.getBoundingClientRectAsObject(blockNode);
      if (oldFocusedBlock !== focusedBlock) {
        const batchUpdates = {};
        batchUpdates.boundingRect = boundingRect;
        batchUpdates.componentData = this.state.componentData;
        batchUpdates.componentState = {};
        batchUpdates.deleteBlock = this.deleteBlock;
        batchUpdates.focusedBlock = focusedBlock;
        pubsub.set(batchUpdates);
      } else {
        pubsub.set("boundingRect", boundingRect);
      }
    }
    updateUnselectedComponent() {
      pubsub.set({ focusedBlock: null, componentData: {}, componentState: {} });
    }
  }, __publicField(_a, "propTypes", {
    block: PropTypes.object.isRequired,
    blockProps: PropTypes.object.isRequired,
    selection: PropTypes.object.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    onDragStart: PropTypes.func
  }), __publicField(_a, "displayName", createHocName("BaseComponent", PluginComponent)), _a;
};

export { createBaseComponent };
//# sourceMappingURL=createBaseComponent.js.map
